import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "./dataSlice";
import marketingReducer from "./marketingSlice";
import uiReducer from "./uiSlice";

const store = configureStore({
  reducer: {
    data: dataReducer,
    marketing: marketingReducer,
    ui: uiReducer,
  }
});

export default store;
